import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Mail, Phone, Shield, Zap, MapPin } from "lucide-react";
import { EMAIL, PHONE_DISPLAY } from "../lib/api";

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200 mt-20" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo />
          <p className="body-text text-sm mt-4 leading-relaxed max-w-xs">
            Christophe Battras · Consulting IA · Genève
            <br />
            Automatisations IA pour PME & indépendants suisses.
          </p>
        </div>

        <div>
          <p className="pill-badge mb-4">Navigation</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="body-text hover:text-[#3ecf8e]">Accueil</Link></li>
            <li><Link to="/services" className="body-text hover:text-[#3ecf8e]">Services</Link></li>
            <li><Link to="/services/receptionniste-ia" className="body-text hover:text-[#3ecf8e]">Réceptionniste IA</Link></li>
            <li><Link to="/services/whatsapp-ia" className="body-text hover:text-[#3ecf8e]">WhatsApp IA</Link></li>
            <li><Link to="/audit-ia" className="body-text hover:text-[#3ecf8e]">Audit gratuit</Link></li>
            <li><Link to="/a-propos" className="body-text hover:text-[#3ecf8e]">À propos</Link></li>
            <li><Link to="/contact" className="body-text hover:text-[#3ecf8e]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <p className="pill-badge mb-4">Contact</p>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2 body-text">
              <Mail size={16} className="accent-text" /> {EMAIL}
            </li>
            <li className="flex items-center gap-2 body-text">
              <Phone size={16} className="accent-text" /> {PHONE_DISPLAY}
            </li>
            <li className="flex items-center gap-2 body-text">
              <MapPin size={16} className="accent-text" /> Genève & Suisse romande
            </li>
          </ul>
          <p className="pill-badge mt-6 mb-3">Confiance</p>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2 body-text">
              <span className="text-base">🇨🇭</span> Données en Suisse
            </li>
            <li className="flex items-center gap-2 body-text">
              <Shield size={16} className="accent-text" /> LPD / FADP
            </li>
            <li className="flex items-center gap-2 body-text">
              <Zap size={16} className="accent-text" /> Réponse sous 24h
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-100">
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col md:flex-row gap-3 justify-between text-xs body-text">
          <p>© 2026 · Christophe Battras · Tous droits réservés</p>
          <div className="flex gap-4">
            <a href="#" className="hover:text-[#3ecf8e]">Mentions légales</a>
            <a href="#" className="hover:text-[#3ecf8e]">Politique de confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
